import { cn } from "@/lib/utils";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export interface DetailStatusOption {
  value: string;
  label: string;
}

interface DetailStatusSelectProps {
  value?: string;
  placeholder: string;
  options: readonly DetailStatusOption[];
  disabled?: boolean;
  onValueChange: (value: string) => void;
}

/**
 * 조회 Drawer 헤더 제목 줄에 놓이는 상태 변경 드롭다운 (CS·유지보수 공용).
 * SelectTrigger 의 shadcn 기본값(text-sm·h-8·실제 border)을 디자인 토큰으로 덮어쓴다.
 * 목록은 다른 화면 드롭다운과 같은 내부 여백을 받도록 SelectGroup 으로 감싼다.
 */
export function DetailStatusSelect({
  value,
  placeholder,
  options,
  disabled = false,
  onValueChange,
}: DetailStatusSelectProps) {
  return (
    <Select
      value={value ?? ""}
      onValueChange={onValueChange}
      disabled={disabled}
    >
      <SelectTrigger
        className={cn(
          // rounded-md·bg-static-white·h-9 는 베이스 클래스보다 우선순위가 낮아 ! 가 필요하다
          "h-9! w-fit shrink-0 gap-2 whitespace-nowrap rounded-md! border-none bg-static-white! px-3 py-2",
          "typo-label-1-semibold text-labels-primary",
          "inset-border-solid-normal",
          // 기본 셰브론은 24px 로 렌더된다 — 디자인은 20px
          "**:data-[slot=select-icon]:size-5",
        )}
        triggerColor="labels-primary"
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}

DetailStatusSelect.displayName = "DetailStatusSelect";
